import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=73650f38&"
import script from "./Commands.vue?vue&type=script&lang=js&"
export * from "./Commands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Commands.vue"
export default component.exports